import $data from 'jaydata/core';

import IndexedDBConverter from './IndexedDBConverter.js';
import IndexedDBStorageProvider from './IndexedDBStorageProvider.js';

export default $data;
